{
  "familyId": "SPR-HOOFDLETTER",
  "questions": [
    {
      "id": "SPR-HOOFDLETTER-001",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "Welk woord in deze zin moet een hoofdletter hebben?\n'Op zaterdag gaat emma naar de markt.'",
      "context": null,
      "options": [
        "zaterdag (dag van de week)",
        "emma (persoonsnaam)",
        "markt (gewoon zelfstandig naamwoord)",
        "gaat (werkwoord)"
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Hoofdletterregels", "content": "Gebruik een hoofdletter bij: namen van personen (Emma, Jan), namen van plaatsen (Amsterdam, Nederland), begin van een zin. Dagen van de week krijgen in het Nederlands GEEN hoofdletter.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_naam",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Emma' is een persoonsnaam en moet met een hoofdletter. Dagen van de week (zaterdag) krijgen in het Nederlands geen hoofdletter. Gewone woorden (markt, gaat) krijgen ook geen hoofdletter. Regel: alleen namen van personen en plaatsen krijgen een hoofdletter (naast het eerste woord van een zin).",
        "solutionSteps": [
          "Stap 1: Zoek de namen → 'emma' is een persoonsnaam",
          "Stap 2: Persoonsnamen krijgen altijd een hoofdletter → Emma",
          "Stap 3: 'zaterdag' is een dag → geen hoofdletter in het Nederlands",
          "Stap 4: 'markt' en 'gaat' zijn gewone woorden → geen hoofdletter"
        ],
        "distractorExplanations": {
          "0": "Dagen van de week (zaterdag, maandag, dinsdag) krijgen in het Nederlands GEEN hoofdletter. Dit is anders dan in het Engels! De fout is dat je de Nederlandse regel verwart met de Engelse.",
          "1": "Correct! 'Emma' is een persoonsnaam en moet met een hoofdletter.",
          "2": "'Markt' is een gewoon zelfstandig naamwoord en krijgt geen hoofdletter. Alleen eigennamen (namen van personen en plaatsen) krijgen een hoofdletter.",
          "3": "Werkwoorden krijgen nooit een hoofdletter (tenzij ze aan het begin van een zin staan). 'Gaat' is een gewoon werkwoord."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.hoofdletter-dag", "label": "Denkt dat dagen een hoofdletter krijgen", "optionIndex": 0 },
          { "id": "spr.hoofdletter-znw", "label": "Denkt dat gewone zelfstandige naamwoorden een hoofdletter krijgen", "optionIndex": 2 },
          { "id": "spr.hoofdletter-ww", "label": "Denkt dat werkwoorden een hoofdletter krijgen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-HOOFDLETTER-002",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct geschreven?",
      "context": null,
      "options": [
        "de hond rent door het park.",
        "De hond rent door het park.",
        "De Hond rent door het park.",
        "De hond Rent door het park."
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Begin van een zin", "content": "Het eerste woord van een zin schrijf je altijd met een hoofdletter.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_zinsbegin",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Het eerste woord van een zin schrijf je altijd met een hoofdletter. 'De' is het eerste woord, dus schrijf je 'De' met een hoofdletter D.",
        "solutionSteps": [
          "Stap 1: Het eerste woord van een zin krijgt een hoofdletter",
          "Stap 2: Controleer of er namen in de zin staan → nee",
          "Stap 3: Alleen 'De' (zinsbegin) krijgt een hoofdletter"
        ],
        "distractorExplanations": {
          "0": "Fout: 'de' begint met een kleine letter, maar het eerste woord van een zin moet een hoofdletter hebben: 'De hond...' De fout is een ontbrekende hoofdletter aan het zinsbegin.",
          "1": "Correct! 'De' begint met een hoofdletter omdat het het eerste woord van de zin is.",
          "2": "Fout: 'Hond' is geen naam en staat niet aan het begin van de zin. De fout is dat een gewoon zelfstandig naamwoord onterecht een hoofdletter heeft gekregen.",
          "3": "Fout: 'Rent' is een gewoon werkwoord in het midden van de zin. De fout is dat een werkwoord onterecht een hoofdletter heeft gekregen — alleen namen en het eerste woord krijgen een hoofdletter."
        }
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "SPR-HOOFDLETTER-003",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "Welke woorden moeten een hoofdletter krijgen in deze zin?\n'vorige week ging ik naar amsterdam met mijn oma.'",
      "context": null,
      "options": [
        "alleen 'amsterdam'",
        "'vorige' en 'amsterdam'",
        "'vorige', 'amsterdam' en 'oma'",
        "geen enkel woord"
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Plaatsnamen", "content": "Namen van steden, landen en plaatsen schrijf je altijd met een hoofdletter: Amsterdam, Nederland, Europa. Het eerste woord van een zin krijgt ook een hoofdletter. Gewone woorden zoals 'oma' krijgen geen hoofdletter.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_plaatsnaam",
      "variantIndex": 3,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Er horen 2 hoofdletters in deze zin: 'Vorige' (begin van de zin) en 'Amsterdam' (plaatsnaam). Het woord 'oma' is geen eigennaam en krijgt dus geen hoofdletter. Regel: hoofdletter bij zinsbegin + eigennamen.",
        "solutionSteps": [
          "Stap 1: Eerste woord 'vorige' → hoofdletter (zinsbegin) → Vorige",
          "Stap 2: 'amsterdam' → hoofdletter (plaatsnaam) → Amsterdam",
          "Stap 3: 'oma' → geen hoofdletter (gewoon woord, geen naam)",
          "Totaal: 2 hoofdletters"
        ],
        "distractorExplanations": {
          "0": "Je vergat de hoofdletter aan het begin van de zin. 'Vorige' is het eerste woord en moet ook een hoofdletter hebben. Regel: het eerste woord van elke zin krijgt een hoofdletter.",
          "1": "Correct! 'Vorige' (zinsbegin) en 'Amsterdam' (plaatsnaam) krijgen een hoofdletter.",
          "2": "'Oma' is geen eigennaam — het is een familieaanduiding. Alleen als je 'oma' als naam gebruikt (bijv. 'Oma Jansen') krijgt het een hoofdletter. Hier is het een gewoon woord.",
          "3": "Elke zin begint met een hoofdletter, en eigennamen krijgen altijd een hoofdletter. Er zijn dus minstens 2 hoofdletters nodig."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.hoofdletter-zinsbegin-vergeten", "label": "Vergeet hoofdletter aan zinsbegin", "optionIndex": 0 },
          { "id": "spr.hoofdletter-familienaam", "label": "Denkt dat familieaanduidingen een hoofdletter krijgen", "optionIndex": 2 },
          { "id": "spr.hoofdletter-geen-nodig", "label": "Denkt dat geen hoofdletters nodig zijn", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-HOOFDLETTER-004",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "Welk woord krijgt hier ONTERECHT een hoofdletter?\n'Mijn Vriend Thomas woont in Rotterdam.'",
      "context": null,
      "options": [
        "Mijn (staat aan het begin van de zin)",
        "Vriend (gewoon zelfstandig naamwoord)",
        "Thomas (persoonsnaam)",
        "Rotterdam (plaatsnaam)"
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Overzicht hoofdletterregels", "content": "Hoofdletter bij: 1) begin van een zin, 2) namen van personen, 3) namen van plaatsen. Gewone woorden zoals 'vriend' krijgen geen hoofdletter.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_combinatie",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Vriend' is een gewoon zelfstandig naamwoord en krijgt geen hoofdletter. Het moet 'vriend' zijn met een kleine letter. 'Mijn' (zinsbegin), 'Thomas' (persoonsnaam) en 'Rotterdam' (plaatsnaam) krijgen wél terecht een hoofdletter. Regel: alleen eigennamen en het eerste woord van een zin krijgen een hoofdletter.",
        "solutionSteps": [
          "Stap 1: 'Mijn' → zinsbegin → hoofdletter terecht ✓",
          "Stap 2: 'Vriend' → gewoon woord → hoofdletter ONTERECHT ✗",
          "Stap 3: 'Thomas' → persoonsnaam → hoofdletter terecht ✓",
          "Stap 4: 'Rotterdam' → plaatsnaam → hoofdletter terecht ✓"
        ],
        "distractorExplanations": {
          "0": "'Mijn' staat aan het begin van de zin en krijgt terecht een hoofdletter. Het eerste woord van elke zin begint met een hoofdletter.",
          "1": "Correct! 'Vriend' is een gewoon woord en krijgt geen hoofdletter. Het moet 'vriend' zijn.",
          "2": "'Thomas' is een persoonsnaam en krijgt terecht een hoofdletter. Persoonsnamen schrijf je altijd met een hoofdletter.",
          "3": "'Rotterdam' is een plaatsnaam en krijgt terecht een hoofdletter. Plaatsnamen schrijf je altijd met een hoofdletter."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.hoofdletter-zinsbegin-onterecht", "label": "Denkt dat zinsbegin-hoofdletter onterecht is", "optionIndex": 0 },
          { "id": "spr.hoofdletter-naam-onterecht", "label": "Denkt dat persoonsnaam-hoofdletter onterecht is", "optionIndex": 2 },
          { "id": "spr.hoofdletter-plaats-onterecht", "label": "Denkt dat plaatsnaam-hoofdletter onterecht is", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-HOOFDLETTER-005",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "Welke woorden hoeven GEEN hoofdletter in deze zin?\n'Op maandag gaat Lisa naar school in Nederland.'",
      "context": null,
      "options": ["maandag en school", "Lisa en Nederland", "maandag en Nederland", "alleen Lisa"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Wanneer geen hoofdletter?", "content": "Gewone zelfstandige naamwoorden (school, huis) en dagen van de week (maandag, dinsdag) krijgen in het Nederlands GEEN hoofdletter. Wel een hoofdletter bij: namen van personen (Lisa) en landen (Nederland).", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_geen",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "In het Nederlands schrijf je dagen van de week (maandag, dinsdag) en gewone zelfstandige naamwoorden (school, huis) met een kleine letter. Persoonsnamen (Lisa) en landnamen (Nederland) krijgen wél een hoofdletter.",
        "solutionSteps": [
          "'maandag' = dag van de week → kleine letter",
          "'school' = gewoon zelfstandig naamwoord → kleine letter",
          "'Lisa' = persoonsnaam → hoofdletter",
          "'Nederland' = landnaam → hoofdletter"
        ],
        "distractorExplanations": {
          "0": "Goed! In het Nederlands schrijf je dagen (maandag) en gewone woorden (school) met een kleine letter. Alleen namen van personen en plaatsen krijgen een hoofdletter.",
          "1": "Lisa is een persoonsnaam en Nederland is een landnaam — die krijgen juist wél een hoofdletter. De woorden zonder hoofdletter zijn 'maandag' en 'school'.",
          "2": "Bijna goed: 'maandag' hoeft inderdaad geen hoofdletter (dag van de week), maar 'Nederland' is een landnaam en krijgt wél een hoofdletter. De twee woorden zonder hoofdletter zijn 'maandag' en 'school'.",
          "3": "Lisa krijgt juist wél een hoofdletter (persoonsnaam). De woorden zonder hoofdletter zijn 'maandag' (dag van de week) en 'school' (gewoon woord)."
        }
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-HOOFDLETTER-006",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "error_spotting",
      "question": "Zoek de hoofdletterfouten in deze tekst en verbeter ze.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Op woensdag gaat jan met zijn moeder naar utrecht. Ze gaan naar het Museum en daarna eten ze een ijsje.",
        "errors": [
          {
            "word": "jan",
            "position": 3,
            "correction": "Jan",
            "explanation": "'Jan' is een persoonsnaam en moet met een hoofdletter."
          },
          {
            "word": "utrecht",
            "position": 8,
            "correction": "Utrecht",
            "explanation": "'Utrecht' is een plaatsnaam en moet met een hoofdletter."
          },
          {
            "word": "Museum",
            "position": 12,
            "correction": "museum",
            "explanation": "'Museum' is een gewoon zelfstandig naamwoord en krijgt geen hoofdletter (tenzij het een eigennaam is)."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hoofdletterregels", "content": "Hoofdletter bij: namen van personen (Jan), namen van plaatsen (Utrecht), begin van een zin. Geen hoofdletter bij: gewone woorden (museum, school, park).", "icon": "book" } }
      ],
      "conceptId": "hoofdletter_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Drie fouten: 'jan' moet 'Jan' zijn (persoonsnaam), 'utrecht' moet 'Utrecht' zijn (plaatsnaam), 'Museum' moet 'museum' zijn (gewoon woord, geen eigennaam). Correct: 'Op' (zinsbegin), 'Ze' (zinsbegin) ✓",
        "solutionSteps": [
          "Fout 1: jan → Jan (persoonsnaam → hoofdletter)",
          "Fout 2: utrecht → Utrecht (plaatsnaam → hoofdletter)",
          "Fout 3: Museum → museum (gewoon woord → kleine letter)",
          "Correct: 'Op' en 'Ze' (zinsbegin) ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-HOOFDLETTER-007",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "Welke woorden in deze zin moeten een hoofdletter krijgen?\n'op maandag fietst emma naar school in amsterdam.'",
      "options": [
        "op, emma, amsterdam",
        "maandag, emma, amsterdam",
        "op, maandag, emma, amsterdam",
        "emma, amsterdam"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hoofdletterregels", "content": "Hoofdletter bij: het eerste woord van een zin ('Op'), namen van personen ('Emma') en plaatsen ('Amsterdam'). Dagen van de week ('maandag') en gewone woorden ('school') krijgen in het Nederlands GEEN hoofdletter.", "icon": "book" } }
      ],
      "conceptId": "hoofdletter_context_mc",
      "variantIndex": 7,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Drie woorden hebben een hoofdletter nodig: 'Op' (begin van de zin), 'Emma' (persoonsnaam) en 'Amsterdam' (plaatsnaam). Het woord 'maandag' is een dag van de week en krijgt in het Nederlands geen hoofdletter. 'School' is een gewoon woord.",
        "solutionSteps": [
          "Zinsbegin: 'op' → 'Op'",
          "Dagen: 'maandag' → geen hoofdletter",
          "Namen: 'emma' → 'Emma'",
          "Plaatsen: 'amsterdam' → 'Amsterdam'"
        ],
        "distractorExplanations": {
          "0": "Goed! Zinsbegin, persoonsnaam en plaatsnaam.",
          "1": "Je vergat het zinsbegin ('op') en je gaf 'maandag' onterecht een hoofdletter. Dagen van de week krijgen in het Nederlands geen hoofdletter.",
          "2": "Je gaf 'maandag' onterecht een hoofdletter. Dagen van de week krijgen in het Nederlands geen hoofdletter.",
          "3": "Je vergat het zinsbegin ('op'). Het eerste woord van een zin krijgt altijd een hoofdletter."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.hoofdletter-dag", "label": "Denkt dat dagen een hoofdletter krijgen", "optionIndex": 2 },
          { "id": "spr.hoofdletter-zinsbegin-vergeten", "label": "Vergeet hoofdletter aan zinsbegin", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-HOOFDLETTER-008",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "fill_in",
      "question": "Schrijf de naam van de stad correct over: 'We gaan op vakantie naar amsterdam.' Typ alleen de stadsnaam.",
      "correctAnswer": "Amsterdam",
      "data": {
        "acceptedAnswers": ["Amsterdam"],
        "caseSensitive": true,
        "placeholder": "typ de stadsnaam"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Plaatsnamen", "content": "Namen van steden schrijf je altijd met een hoofdletter: Amsterdam, Rotterdam, Utrecht.", "icon": "book" } }
      ],
      "conceptId": "hoofdletter_fill",
      "variantIndex": 8,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Amsterdam' is een plaatsnaam en schrijf je met een hoofdletter. Regel: namen van steden, landen en plaatsen krijgen altijd een hoofdletter.",
        "solutionSteps": [
          "Amsterdam is een plaatsnaam",
          "Plaatsnamen krijgen een hoofdletter",
          "Schrijf: Amsterdam (met hoofdletter A)"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "SPR-HOOFDLETTER-009",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "sentence_error_judge",
      "question": "Welke zin heeft een fout met hoofdletters?",
      "data": {
        "sentences": [
          { "text": "Mijn oom woont in spanje.", "hasError": true, "correction": "Mijn oom woont in Spanje.", "explanation": "Namen van landen (Spanje) krijgen altijd een hoofdletter." },
          { "text": "Op dinsdag eten we altijd pannenkoeken.", "hasError": false },
          { "text": "De hond van de buren heet Max.", "hasError": false },
          { "text": "Gisteren ben ik naar de dierentuin geweest.", "hasError": false }
        ]
      },
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hoofdletterregels", "content": "Hoofdletter bij: het eerste woord van een zin, namen van personen (Max) en landen (Spanje). Dagen van de week (dinsdag) krijgen in het Nederlands GEEN hoofdletter.", "icon": "book" } }
      ],
      "conceptId": "hoofdletter_sentence_judge",
      "variantIndex": 9,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Zin 1 is fout: 'spanje' moet 'Spanje' zijn (landnaam). De andere zinnen zijn correct: dagen (dinsdag) krijgen geen hoofdletter, namen (Max) en zinsbegin (Gisteren) wel.",
        "solutionSteps": [
          "Zin 1: 'spanje' is een land → moet 'Spanje' zijn ✗",
          "Zin 2: 'dinsdag' is een dag → kleine letter klopt ✓",
          "Zin 3: Zinsbegin ('De') en naam ('Max') kloppen ✓",
          "Zin 4: Zinsbegin ('Gisteren') klopt ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-HOOFDLETTER-010",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "sentence_error_judge",
      "question": "Beoordeel elke zin: zijn de hoofdletters correct?",
      "data": {
        "sentences": [
          { "text": "Lisa woont in Rotterdam.", "hasError": false },
          { "text": "Op Maandag gaan we zwemmen.", "hasError": true, "correction": "Op maandag gaan we zwemmen.", "explanation": "'Maandag' is een dag van de week en krijgt in het Nederlands geen hoofdletter. Het moet 'maandag' zijn." },
          { "text": "Mijn broer heet Thomas.", "hasError": false },
          { "text": "We gaan naar Nederland op vakantie.", "hasError": false }
        ]
      },
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hoofdletterregels", "content": "Hoofdletter bij: namen (Lisa, Thomas, Rotterdam, Nederland), zinsbegin. Geen hoofdletter bij: dagen (maandag), gewone woorden.", "icon": "book" } }
      ],
      "conceptId": "hoofdletter_error_judge",
      "variantIndex": 10,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De fout zit in zin 2: 'Maandag' moet 'maandag' zijn. Dagen van de week krijgen in het Nederlands geen hoofdletter. De andere zinnen zijn correct: Lisa (persoonsnaam) ✓, Rotterdam (plaatsnaam) ✓, Thomas (persoonsnaam) ✓, Nederland (landnaam) ✓.",
        "solutionSteps": [
          "Zin 1: Lisa (naam) + Rotterdam (plaats) → correct ✓",
          "Zin 2: Maandag → dag van de week → geen hoofdletter → fout ✗",
          "Zin 3: Thomas (naam) → correct ✓",
          "Zin 4: Nederland (land) → correct ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-HOOFDLETTER-011",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "error_spotting",
      "question": "Zoek de hoofdletterfouten in deze tekst en verbeter ze.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "mijn tante woont in spanje. Ze spreekt heel goed spaans.",
        "errors": [
          {
            "word": "mijn",
            "position": 0,
            "correction": "Mijn",
            "explanation": "Het eerste woord van een zin krijgt altijd een hoofdletter."
          },
          {
            "word": "spanje",
            "position": 4,
            "correction": "Spanje",
            "explanation": "Namen van landen krijgen altijd een hoofdletter."
          },
          {
            "word": "spaans",
            "position": 9,
            "correction": "Spaans",
            "explanation": "Namen van talen krijgen altijd een hoofdletter."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hoofdletterregels", "content": "Hoofdletter bij: het eerste woord van een zin, namen van landen (Spanje) en namen van talen (Spaans).", "icon": "book" } }
      ],
      "conceptId": "hoofdletter_error_spotting_talen",
      "variantIndex": 11,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Drie fouten: 'mijn' moet 'Mijn' zijn (zinsbegin), 'spanje' moet 'Spanje' zijn (landnaam), en 'spaans' moet 'Spaans' zijn (taal).",
        "solutionSteps": [
          "Fout 1: mijn → Mijn (zinsbegin → hoofdletter)",
          "Fout 2: spanje → Spanje (landnaam → hoofdletter)",
          "Fout 3: spaans → Spaans (taal → hoofdletter)"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}